module.exports = __webpack_public_path__ + "assets/img/rental1.0a9e6061.jpg";